import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MdKanbanFormChequeDepotItemDialogComponent } from '../md-kanban-form-cheque-depot-item-dialog/md-kanban-form-cheque-depot-item-dialog.component';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { AbwConfirmDialogService } from 'src/app/shared/abw-confirm-dialog/abw-confirm-dialog.service';
import {v4 as uuidv4} from 'uuid';

@Component({
    selector: 'md-kanban-form-cheque-depot-dialog',
    templateUrl: './md-kanban-form-cheque-depot-dialog.component.html',
    styleUrls: ['./md-kanban-form-cheque-depot-dialog.component.scss']
})
export class MdKanbanFormChequeDepotDialogComponent implements OnInit {
    loading = false;
    depotFormGroup = this._formBuilder.group({
        BANQUE: [null, Validators.required],
        NUM_BORDEREAU: [null],
        CHEQUES: [[], Validators.required]
    });
    kanbanItem: any;
    item?: any;
    startupInfos: any;
    
    constructor(
        private _formBuilder: FormBuilder,
        private _dialog: MatDialog,
        private _confirmDialog: AbwConfirmDialogService,
        public dialogRef: MatDialogRef<MdKanbanFormChequeDepotDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { kanbanItem: any, startupInfos: any, item?: any },
    ) {
        this.kanbanItem = data.kanbanItem;
        this.startupInfos = data.startupInfos;
        this.item = data.item;
        if (!!data.item) {
            this.depotFormGroup.patchValue({
                BANQUE: data.item.PARAMS_TASK.BANQUE,
                NUM_BORDEREAU: data.item.PARAMS_TASK.NUM_BORDEREAU,
                MONTANT_FACTURE: data.item.PARAMS_TASK.MONTANT_FACTURE
            });
        }
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close(false);
    }

    get f() {
        return this.depotFormGroup.controls;
    }

    onSubmit() {
        if (this.depotFormGroup.invalid) { return; }
        this.dialogRef.close({ data: this.depotFormGroup.value});
    }

    get totalMontantCheques() {
        let total = 0;
        const cheques: any[] = this.depotFormGroup.controls.CHEQUES.value;
        if (!!cheques) {
            total = cheques.reduce((currentTotal, currentCheque) => {
                const currentChequeMontant = !isNaN(currentCheque.MONTANT_CHEQUE) ? parseFloat(currentCheque.MONTANT_CHEQUE) : 0;
                return currentChequeMontant + currentTotal;
            }, 0);
        }
        return total;
    }

    async doOpenAddChequeDialog(item?: any) {
        const resultDialog = await this._dialog.open(MdKanbanFormChequeDepotItemDialogComponent, {
            data: { item: item, startupInfos: this.startupInfos },
            width: '100vw',
            panelClass: 'datasource-designer-modal'
        }).afterClosed().toPromise();

        if (!!resultDialog) {
            const cheques: any[] = this.depotFormGroup.controls.CHEQUES.value;
            const index = !!resultDialog.ID ? cheques.findIndex(c => c.ID == resultDialog.ID) : -1;
            if (index > -1) {
                cheques[index] = resultDialog;
            } else {
                resultDialog.ID = uuidv4();
                cheques.push(resultDialog);
            }
            this.depotFormGroup.controls.CHEQUES.patchValue(cheques);
        }
    }

    async doRemoveChequeAction(item: any, index: number) {
        const confirmation = await this._confirmDialog.showConfirmDialog('Dépot de chèque', 'Voulez-vous vraiment supprimer ce chèque ?');
        if (confirmation) {
            const cheques: any[] = this.depotFormGroup.controls.CHEQUES.value;
            cheques.splice(index, 1)
            this.depotFormGroup.controls.CHEQUES.patchValue(cheques);
        }
    }

    onBanqueSelected(banqueId: any) {
        const banque = this.startupInfos.BANQUES.find(b => b.ID == banqueId);
        if (!!banque) {
            this.depotFormGroup.controls.BANQUE.patchValue(banque);
        }
    }
}